import numeral from "numeral";
import dayjs from "dayjs";
export var PhoneType;
(function(PhoneType) {
    PhoneType[PhoneType["default"] = 0] = "default";
})(PhoneType || (PhoneType = {}));
export const priceFormatter = (price)=>{
    return numeral(price).format("0,0");
};
export const priceWithStringFormatter = (price)=>{
    return numeral(price).format("0,0") + "원";
};
export const numberFormatter = (price)=>{
    return numeral(price).format("0,0");
};
export const dateFormatter = (date)=>{
    return dayjs(date).format("YYYY. MM. DD. A HH:mm");
};
export const dateTransFormatter = (date)=>{
    return dayjs(date).format("YYYY. MM. DD");
};
export const dateKorFormatter = (date)=>{
    return dayjs(date).format("YYYY.MM.DD");
};
/**
 * 값이 없거나 파싱할 수 없으면 `null` — 화면에서 해당 영역을 통째로 감추기 위한 포맷터.
 *
 * `dateKorFormatter` 를 그대로 쓰면 안 되는 이유:
 * - `undefined` 는 `dayjs()` 와 같아 **오늘 날짜**가 된다. 그럴듯해 보여서 틀린 날짜가 조용히 노출된다
 * - `null`·빈 문자열은 `'Invalid Date'` 라는 문자열이 그대로 화면에 찍힌다
 */ export const dateKorFormatterOrNull = (date)=>{
    if (!date) return null;
    const parsed = dayjs(date);
    return parsed.isValid() ? parsed.format("YYYY.MM.DD") : null;
};
export function phoneFormatter(num) {
    let type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : PhoneType.default;
    var formatNum = "";
    if (num.length === 11) {
        if (type === 0) {
            formatNum = num.replace(/(\d{3})(\d{4})(\d{4})/, "$1-****-$3");
        } else {
            formatNum = num.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
        }
    } else if (num.length === 8) {
        formatNum = num.replace(/(\d{4})(\d{4})/, "$1-$2");
    } else {
        if (num.indexOf("02") === 0) {
            if (type === 0) {
                formatNum = num.replace(/(\d{2})(\d{3,4})(\d{4})/, "$1-****-$3");
            } else {
                formatNum = num.replace(/(\d{2})(\d{3,4})(\d{4})/, "$1-$2-$3");
            }
        } else {
            if (type === 0) {
                formatNum = num.replace(/(\d{3})(\d{3,4})(\d{4})/, "$1-***-$3");
            } else {
                formatNum = num.replace(/(\d{3})(\d{3,4})(\d{4})/, "$1-$2-$3");
            }
        }
    }
    return formatNum;
}
